import React, { useEffect } from 'react';
import { arrayOf, string, object, func } from 'prop-types';
import ClientList from '../../../shared/NotableClients/ClientList';
import WithImpressions from '../../../shared/withImpressions';
import TopClientsTitle from '../../../shared/NotableClients/TopClientsTitle';
import { getDisplayedNotableClients } from '../../../shared/NotableClients/helper';
import './style.scss';

const CLASS_NAME = 'notable-clients-about';
const SUB_CLASS_NAME = 'client-list';

const NotableClientsAbout = ({ notableClients, sellerName, profilePhoto, collectImpressions, impressionRef }) => {

    useEffect(() => {
        collectImpressions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const clientListProps = {
        displayClients: getDisplayedNotableClients(notableClients),
        sellerName,
        profilePhoto,
        showIndustry: true,
        oddsPopoverPositionLeft: true,
        source: ClientList.SOURCES.BELOW_THE_FOLD
    };

    return (
        <div className="notable-clients-about m-t-16 p-t-16" ref={impressionRef}>
            <TopClientsTitle sellerName={sellerName} newBadge fontSize="16"/>
            <ul className="client-list">
                <ClientList {...clientListProps}/>
            </ul>
        </div>
    );
};

const impressionConfig = {
    DOMSelector: `.${CLASS_NAME} > .${SUB_CLASS_NAME}`,
    eventKey: 'notable_client_below_the_fold_component_is_shown'
};

NotableClientsAbout.propTypes = {
    notableClients: arrayOf(object),
    sellerName: string,
    profilePhoto: string,
    collectImpressions: func,
    impressionRef: object
};

export { NotableClientsAbout };
export default WithImpressions(NotableClientsAbout, impressionConfig);
